import { render, staticRenderFns } from "./ShipmentAddPopup.vue?vue&type=template&id=4e8303c0&"
import script from "./ShipmentAddPopup.vue?vue&type=script&lang=js&"
export * from "./ShipmentAddPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports